module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nongsa-2021-desktop.jpg?v=6163fca5";